import { Page, Cashback, ItemCashback, CashbackListagem } from "@/models"
import { AxiosRequestConfig } from "axios"
import { Inject } from "inversify-props"
import type { CashbackServiceAdapter } from "./adapter/CashbackServiceAdapter"
import { CampanhaCashback } from "@/models/CampanhaCashback"
import { AcaoDeCashback } from "@/models/AcaoDeCashback"
import { DashboardDaAcaoDobro, DashboardDaAcaoData } from "@/models/DashboardDaAcaoDeCashback"
import { ResumoDaMetaDeAcaoDeCashback } from "@/models/MetaDeAcaoDeCashback"

export class FindCashbackUseCase {
	@Inject('CashbackServiceAdapter')
	private cashBackServiceAdapter!: CashbackServiceAdapter

	findCashBackPorCliente = async (params?: any, config?: AxiosRequestConfig): Promise<Page<Cashback>> =>
		await this.cashBackServiceAdapter.findCashBackPorCliente(params, config)

	findItensCashback = async (params?: any, config?: AxiosRequestConfig): Promise<Page<ItemCashback>> =>
		await this.cashBackServiceAdapter.findItensCashback(params, config) 

	findCampanhas = async (params?: any, config?: AxiosRequestConfig): Promise<Page<CampanhaCashback>> =>
		await this.cashBackServiceAdapter.findCampanhas(params, config)

	findListagemDeCashback = async (params?: any, config?: AxiosRequestConfig): Promise<Page<CashbackListagem>> =>
		await this.cashBackServiceAdapter.findListagemDeCashback(params, config)

	findById = async (id: string): Promise<Cashback> => 
		await this.cashBackServiceAdapter.get(id)

	findAcoesDeCashback = async (params?: any, config?: AxiosRequestConfig): Promise<Page<AcaoDeCashback>> =>
		await this.cashBackServiceAdapter.findAcoesDeCashback(params, config)

	findListaAcoesDeCashback = async (params?: any, config?: AxiosRequestConfig): Promise<AcaoDeCashback[]> => 
		await this.cashBackServiceAdapter.findListaAcoesDeCashback(params, config)

	possuiPluginDeEnvioCashbackGerado = async (lojaId: string): Promise<boolean> =>
		await this.cashBackServiceAdapter.possuiPluginDeEnvioCashbackGerado(lojaId)

	enviarMensagemDeCashbackGeradoNaVenda = async (identificador: string): Promise<void> =>
		await this.cashBackServiceAdapter.enviarMensagemDeCashbackGeradoNaVenda(identificador)

	findCashbacksPendentesDeAtivacao = async (params?: any, config?: AxiosRequestConfig): Promise<Cashback[]> =>
		await this.cashBackServiceAdapter.findCashbacksPendentesDeAtivacao(params, config)

	buscarDashboardDaAcaoDeDobro = async (acaoId: string): Promise<DashboardDaAcaoDobro> =>
		await this.cashBackServiceAdapter.buscarDashboardDaAcaoDeDobro(acaoId)

	buscarDashboardDaAcaoDeData = async (acaoId: string): Promise<DashboardDaAcaoData> =>
		await this.cashBackServiceAdapter.buscarDashboardDaAcaoDeData(acaoId)

	findMetaDaAcaoDeCashback = async (acaoId: string): Promise<ResumoDaMetaDeAcaoDeCashback> =>
		await this.cashBackServiceAdapter.findMetaDaAcaoDeCashback(acaoId)

	findMetasDasAcoesDeCashback = async (acaoIds: string[]): Promise<ResumoDaMetaDeAcaoDeCashback[]> =>
		await this.cashBackServiceAdapter.findMetasDasAcoesDeCashback(acaoIds)
}